// Publishes the storefront interactions Shopify has no standard customer event
// for, so the custom pixels (pixels/ga4-custom-pixel.js and
// pixels/meta-custom-pixel.js in the repo, pasted into Settings > Customer
// events) can subscribe to them like any other event.
//
// Shopify requires custom events to be namespaced so they can't collide with
// its standard ones; everything here is forge_fyre:*. Nothing in this file
// knows or cares which analytics vendor is listening.
//
// Loaded on every template from layout/theme.liquid.
(function () {
  'use strict';

  function publish(name, payload) {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') {
      return;
    }
    try {
      Shopify.analytics.publish(name, payload);
    } catch (e) {
      // Analytics must never break the storefront.
    }
  }

  // -------------------------------------------------------------------------
  // Scroll depth
  //
  // forge_fyre:scroll_depth { percent, path } once per threshold per page
  // load. Percent is how much of the page's height has been on screen, so a
  // page short enough to fit the viewport reports every threshold on load —
  // the customer did see all of it.
  // -------------------------------------------------------------------------
  var THRESHOLDS = [25, 50, 75, 90];
  var reached = {};
  var scheduled = false;

  function depthPercent() {
    var doc = document.documentElement;
    var body = document.body;
    var pageHeight = Math.max(
      doc ? doc.scrollHeight : 0,
      body ? body.scrollHeight : 0
    );
    if (!pageHeight) return 0;

    var viewport = window.innerHeight || (doc && doc.clientHeight) || 0;
    var scrolled = window.pageYOffset || (doc && doc.scrollTop) || 0;

    return Math.min(100, Math.round(((scrolled + viewport) / pageHeight) * 100));
  }

  function checkDepth() {
    scheduled = false;
    var percent = depthPercent();

    for (var i = 0; i < THRESHOLDS.length; i++) {
      var threshold = THRESHOLDS[i];
      if (percent >= threshold && !reached[threshold]) {
        reached[threshold] = true;
        publish('forge_fyre:scroll_depth', {
          percent: threshold,
          path: window.location.pathname
        });
      }
    }
  }

  // A plain timer rather than requestAnimationFrame: animation frames stop in
  // background tabs and some embedded browsers, and a check that never runs
  // would leave the flag set and silence scroll depth for the rest of the page.
  var CHECK_DELAY = 100;

  function scheduleCheck() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(checkDepth, CHECK_DELAY);
  }

  window.addEventListener('scroll', scheduleCheck, { passive: true });
  window.addEventListener('resize', scheduleCheck, { passive: true });

  // Measure once the page has its final height, not while images are still
  // pushing the footer down.
  if (document.readyState === 'complete') {
    scheduleCheck();
  } else {
    window.addEventListener('load', scheduleCheck);
  }

  // -------------------------------------------------------------------------
  // Product card clicks
  //
  // forge_fyre:product_card_click with the product and list details that
  // snippets/product-card.liquid puts in data attributes. Delegated so it
  // covers every grid (collection, featured collection, search) and survives
  // sections being re-rendered by the theme editor.
  // -------------------------------------------------------------------------
  var NAV_DELAY = 120;

  function numberOrNull(value, parser) {
    if (value == null || value === '') return null;
    var n = parser(value, 10);
    return isNaN(n) ? null : n;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var card = target.closest('[data-product-card]');
    if (!card) return;

    var data = card.dataset;

    publish('forge_fyre:product_card_click', {
      product_id: data.productId || null,
      variant_id: data.variantId || null,
      handle: data.productHandle || null,
      title: data.productTitle || null,
      price: numberOrNull(data.productPrice, parseFloat),
      currency: data.currency || null,
      position: numberOrNull(data.position, parseInt),
      list_id: data.listId || null,
      list_name: data.listName || null,
      url: card.getAttribute('href')
    });

    // A plain click navigates away, and the pixel sandbox that forwards this
    // event is torn down with the page before it can send anything. Hold the
    // navigation for a beat so the event gets out. Modified clicks and
    // new-tab links don't unload this page, so they are left alone.
    var href = card.getAttribute('href');
    if (!href) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (card.target && card.target !== '_self') return;

    event.preventDefault();
    window.setTimeout(function () {
      window.location.href = href;
    }, NAV_DELAY);
  });

  // -------------------------------------------------------------------------
  // "Add all to cart" successes
  //
  // assets/add-collection.js dispatches a DOM event when its request succeeds
  // rather than calling analytics itself. This is where that becomes
  // forge_fyre:collection_add_to_cart. The per-product add_to_cart events are
  // Shopify's standard product_added_to_cart and need nothing from here.
  // -------------------------------------------------------------------------
  document.addEventListener('forge-fyre:collection-added', function (event) {
    publish('forge_fyre:collection_add_to_cart', event.detail || {});
  });
})();
